import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import Input from "../../../Components/Input";
import ModelContainer from "../../../Components/ModelContainer";
import Select from "../../../Components/Select";
import DateInput from "../../../Components/DateInput";
import MultiSelect from "../../../Components/MultiSelect";

const Clipboard = (params) => {
  const dispatch = useDispatch();

  const clipboardData = useSelector(
    (state) => state?.settingReducer?.clipboardData
  );

  const [formState, setFormState] = useState({
    day_time_id: 1,
    checkboxes_order: [],
    order_same_for_all_day: "",
    enable_tags: "",
    notepad_same_for_all_day: "",
    reminders: "",
    cut_off_time: "",
    enable_alerts: "",
    alert_clipboard: "",
    alert_dashboard: "",
    alert_email: "",
    enable_statuses: "",
    event_same_for_all_day: "",
    count_same_for_all_day: "",
    require_reason_cash_break: "",
    reminder_time: "",
  });
  useEffect(() => {
    console.log("aaaaaaaaaaaaaaaaa");
    dispatch(
      actions.getClipBoardData({ dayTime: formState?.day_time_id ?? 1 })
    );
  }, [formState?.day_time_id]);

  useEffect(() => {
    setFormState({
      ...formState,
      day_time_id: clipboardData?.feature?.day_time_id,
      checkboxes_order: clipboardData?.feature?.checkboxes_order,
      // order_same_for_all_day: clipboardData?.feature?.,
      enable_tags: clipboardData?.feature?.enable_tags,
      // notepad_same_for_all_day: clipboardData?.feature?.,
      reminders: clipboardData?.feature?.reminders,
      cut_off_time: clipboardData?.feature?.cut_off_time,
      enable_alerts: clipboardData?.feature?.enable_alerts,
      alert_clipboard: clipboardData?.feature?.alert_dashboard,
      alert_dashboard: clipboardData?.feature?.alert_dashboard,
      alert_email: clipboardData?.feature?.alert_email,
      enable_statuses: clipboardData?.feature?.enable_statuses,
      // event_same_for_all_day: clipboardData?.feature?.,
      // count_same_for_all_day: clipboardData?.feature?.,
      require_reason_cash_break:
        clipboardData?.feature?.require_reason_cash_break,
      reminder_time: clipboardData?.feature?.reminder_time,
    });
  }, [clipboardData]);

  const checkListModalState = useSelector(
    (state) => state?.settingReducer?.clipboard_checklist_modal_state
  );
  const setCheckListModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "clipboard_checklist_modal_state",
        modalState: state,
      })
    );

  const [featureData, setFeatureData] = useState({
    checkboxesOrder: [],
    activeCheckbox: "checklist_order",
    activeDayTimeId: 1,
  });

  useEffect(() => {
    setFormState({
      ...formState,
      checkboxes_order: featureData?.checkboxesOrder?.map((el) => el.value),
    });
  }, [featureData?.checkboxesOrder]);

  useEffect(() => {
    const checkboxesOrder = clipboardData?.feature?.checkboxes_order?.map(
      (el) => ({
        value: el,
        name: clipboardData?.checkboxes_order_labels[el],
      })
    );
    setFeatureData({
      ...featureData,
      checkboxesOrder: checkboxesOrder,
    });
  }, [clipboardData]);

  function getCheckListFrequency(el) {
    let frequencyType = "";
    const frequencyName = clipboardData?.frequencies?.find(
      (elem) => elem?.value === el?.recurrence
    )?.label;

    if (frequencyName === "Daily") {
      frequencyType = clipboardData?.daily?.find(
        (elem) => elem?.value === el?.daily
      )?.label;
    }
    if (frequencyName === "Weekly") {
      frequencyType = el?.weekly.join(",");
    }
    if (frequencyName === "Monthly") {
      frequencyType = clipboardData?.monthly?.find(
        (elem) => elem?.value === el?.monthly
      )?.label;
      if (frequencyType === "Day of Month") frequencyType += " : " + el?.mdom;
    }

    if (frequencyName === "Yearly") {
      frequencyType = clipboardData?.anually?.find(
        (elem) => elem?.value === el?.anually
      )?.label;
      console.log(frequencyType === "Day of Year", "lllllllllllllllllll");
      if (frequencyType === "Day of Year") frequencyType += " : " + el?.adoy;
    }
    return `${frequencyName} (${frequencyType})`;
  }

  return (
    <UserInterface>
      {console.log("checkkkkkkkkkkk", featureData?.checkboxesOrder)}
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div class="bg_white_dark">
          <div class="content2">
            <div className="container px-0">
              <div class="inner_content">
                <div class="main-top-bar2">
                  <ul class="steps">
                    <li
                      onClick={() =>
                        setFormState({ ...formState, day_time_id: 1 })
                      }
                      class={formState?.day_time_id === 1 ? "active" : ""}
                    >
                      <a>Morning</a>{" "}
                    </li>
                    <li
                      onClick={() =>
                        setFormState({ ...formState, day_time_id: 2 })
                      }
                      class={formState?.day_time_id === 2 ? "active" : ""}
                    >
                      <a>Afternoon</a>{" "}
                    </li>
                    <li
                      onClick={() =>
                        setFormState({ ...formState, day_time_id: 3 })
                      }
                      class={formState?.day_time_id === 3 ? "active" : ""}
                    >
                      <a>Night</a>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass">
              <div className="row">
                <div className="col-lg-3 col-12">
                  <h5 className="event-alert">Select Morning Features:</h5>
                  <div className="move-area">
                    <ul class="move-nav">
                      <li
                        onClick={() => {
                          const arr = [...featureData?.checkboxesOrder];
                          const selectedIndex = arr?.findIndex(
                            (el) => el?.value === featureData?.activeCheckbox
                          );

                          if (selectedIndex === 0) return;
                          const deletedEl = arr.splice(selectedIndex, 1);
                          arr.splice(selectedIndex - 1, 0, deletedEl[0]);

                          setFeatureData({
                            ...featureData,
                            checkboxesOrder: arr,
                          });
                        }}
                      >
                        <a id="move_up">
                          <i class="up-arrow icons"></i>Move Up
                        </a>
                      </li>
                      <li
                        onClick={() => {
                          const arr = [...featureData?.checkboxesOrder];
                          const selectedIndex = arr?.findIndex(
                            (el) => el?.value === featureData?.activeCheckbox
                          );

                          if (selectedIndex === arr.length - 1) return;
                          const deletedEl = arr.splice(selectedIndex, 1);
                          arr.splice(selectedIndex + 1, 0, deletedEl[0]);

                          setFeatureData({
                            ...featureData,
                            checkboxesOrder: arr,
                          });
                        }}
                      >
                        <a id="move_down">
                          <i class="down-arrow icons"></i>Move Down
                        </a>
                      </li>
                    </ul>

                    <ul class="feat-nav-move">
                      {featureData?.checkboxesOrder?.map((el) => {
                        return (
                          <li
                            class={`features_li ${
                              featureData?.activeCheckbox == el?.value
                                ? "active"
                                : ""
                            }`}
                            type="notepad"
                            onClick={() => {
                              setFeatureData({
                                ...featureData,
                                activeCheckbox: el?.value,
                              });
                            }}
                          >
                            <input
                              checked=""
                              type="checkbox"
                              id="notepad_check"
                              class="features_checkbox"
                            />
                            <label for="notepad_check"></label>
                            <span class="features_activate">{el?.name}</span>
                          </li>
                        );
                      })}
                    </ul>
                    <div class="checkbox d-flex clearfix w-100">
                      <input
                        type="checkbox"
                        name="data[Feature][enable_tags]"
                        value="1"
                        id="Same for all day"
                      />
                      <label for="Same for all day">Same for all day</label>{" "}
                    </div>
                  </div>
                </div>

                <div className="col-lg-9 col-12 border-right">
                  <div className="row mx-0">
                    {featureData?.checkboxesOrder?.map((featureItem) => {
                      let res = null;
                      switch (featureItem?.value) {
                        case "notepad_order":
                          res = (
                            <>
                              <h5 className="event-alert w-100">
                                Notepad Setup
                              </h5>
                              <ul className="clipCheck">
                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        enable_tags:
                                          formState?.enable_tags === 1 ? 0 : 1,
                                      })
                                    }
                                    checked={
                                      formState?.enable_tags === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][enable_tags]"
                                    value="1"
                                    id="EnableTags"
                                  />
                                  <label for="EnableTags">Enable Tags</label>{" "}
                                </li>
                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        order_same_for_all_day:
                                          formState?.order_same_for_all_day ===
                                          1
                                            ? 0
                                            : 1,
                                      })
                                    }
                                    checked={
                                      formState?.order_same_for_all_day === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][notepad_same_for_all_day]"
                                    value="1"
                                    id="FeatureNotepadSameForAllDay"
                                  />
                                  <label for="FeatureNotepadSameForAllDay">
                                    Same for all day
                                  </label>{" "}
                                </li>
                              </ul>
                            </>
                          );
                          break;
                        case "checklist_order":
                          res = (
                            <>
                              <h5 className="event-alert w-100">
                                Checklist Setup
                              </h5>

                              <div class="inner-space description-table">
                                <div class="table-responsive">
                                  <table
                                    class="checklist-table"
                                    width="100%"
                                    cellspacing="0"
                                    cellpadding="0"
                                  >
                                    <thead>
                                      <tr>
                                        <th width="50%">Description</th>
                                        <th width="50%">Frequency</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {clipboardData?.feature?.checklist_description?.map(
                                        (el) => {
                                          return (
                                            <tr>
                                              <td width="50%">
                                                <div
                                                  onClick={() =>
                                                    dispatch(
                                                      actions.deleteClipBoardDescription(
                                                        {
                                                          desc_id: el.id,
                                                        }
                                                      )
                                                    )
                                                  }
                                                  className="circle_icon delete_tooltip"
                                                >
                                                  <i
                                                    class="iconSprites delete-icon deleteDescription"
                                                    desc_id="32"
                                                  ></i>
                                                </div>{" "}
                                                {el?.description}
                                              </td>
                                              <td width="50%">
                                                {getCheckListFrequency(el)}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>

                                  <div class="my-3">
                                    <button
                                      onClick={() =>
                                        setCheckListModalState(true)
                                      }
                                      class="btn green-btn-revert add-plus addSp"
                                      id="open_popup"
                                      type="button"
                                    >
                                      <i class="i-icon"> </i> Add Checklist
                                      Setup
                                    </button>
                                  </div>
                                  <ul className="clipCheck">
                                    <li class="checkbox">
                                      <input
                                        onClick={() =>
                                          setFormState({
                                            ...formState,
                                            reminders:
                                              formState?.reminders === 1
                                                ? 0
                                                : 1,
                                          })
                                        }
                                        checked={
                                          formState?.reminders === 1
                                            ? true
                                            : false
                                        }
                                        type="checkbox"
                                        name="data[Feature][enable_tags]"
                                        value="1"
                                        id="reminders"
                                      />
                                      <label for="reminders">Reminders</label>{" "}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          );
                          break;
                        case "event_order":
                          res = (
                            <>
                              {" "}
                              <h5 className="event-alert w-100">
                                Events Setup
                              </h5>
                              <ul className="clipCheck">
                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        enable_alerts:
                                          formState?.enable_alerts === 1
                                            ? 0
                                            : 1,
                                      })
                                    }
                                    checked={
                                      formState?.enable_alerts === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][enable_tags]"
                                    value="1"
                                    id="EnableAlerts"
                                  />
                                  <label for="EnableAlerts">
                                    Enable Alerts
                                  </label>{" "}
                                </li>
                                {formState?.enable_alerts === 1 && (
                                  <li class="checkbox on_enable_alerts hide">
                                    <label class="no-style">AlertTypes:</label>
                                    <ul>
                                      <li>
                                        <input
                                          onClick={() =>
                                            setFormState({
                                              ...formState,
                                              alert_clipboard:
                                                formState?.alert_clipboard === 1
                                                  ? 0
                                                  : 1,
                                            })
                                          }
                                          checked={
                                            formState?.alert_clipboard === 1
                                              ? true
                                              : false
                                          }
                                          type="checkbox"
                                          name="data[Feature][alert_clipboard]"
                                          id="FeatureAlertClipboard"
                                          value="0"
                                        />
                                        <label for="FeatureAlertClipboard">
                                          Clipboard
                                        </label>{" "}
                                      </li>
                                      <li>
                                        <input
                                          onClick={() =>
                                            setFormState({
                                              ...formState,
                                              alert_dashboard:
                                                formState?.alert_dashboard === 1
                                                  ? 0
                                                  : 1,
                                            })
                                          }
                                          checked={
                                            formState?.alert_dashboard === 1
                                              ? true
                                              : false
                                          }
                                          type="checkbox"
                                          name="data[Feature][alert_dashboard]"
                                          class="require_one"
                                          value="1"
                                          id="FeatureAlertDashboard"
                                        />
                                        <label for="FeatureAlertDashboard">
                                          Dashboard
                                        </label>{" "}
                                      </li>
                                      <li>
                                        <input
                                          onClick={() =>
                                            setFormState({
                                              ...formState,
                                              alert_email:
                                                formState?.alert_email === 1
                                                  ? 0
                                                  : 1,
                                            })
                                          }
                                          checked={
                                            formState?.alert_email === 1
                                              ? true
                                              : false
                                          }
                                          type="checkbox"
                                          name="data[Feature][alert_email]"
                                          class="require_one"
                                          value="1"
                                          id="FeatureAlertEmail"
                                        />
                                        <label for="FeatureAlertEmail">
                                          Email
                                        </label>{" "}
                                      </li>
                                    </ul>
                                  </li>
                                )}
                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        enable_statuses:
                                          formState?.enable_statuses === 1
                                            ? 0
                                            : 1,
                                      })
                                    }
                                    checked={
                                      formState?.enable_statuses === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][notepad_same_for_all_day]"
                                    value="1"
                                    id="EnableStatus"
                                  />
                                  <label for="EnableStatus">
                                    Enable Statuses
                                  </label>{" "}
                                </li>

                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        event_same_for_all_day:
                                          formState?.event_same_for_all_day ===
                                          1
                                            ? 0
                                            : 1,
                                      })
                                    }
                                    checked={
                                      formState?.event_same_for_all_day === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][notepad_same_for_all_day]"
                                    value="1"
                                    id="sameAllDays"
                                  />
                                  <label for="sameAllDays">
                                    Same for all day
                                  </label>{" "}
                                </li>
                              </ul>
                            </>
                          );
                          break;
                        case "count_order":
                          res = (
                            <>
                              {" "}
                              <h5 className="event-alert w-100">Count Setup</h5>
                              <ul className="clipCheck">
                                <li class="yes-no-sec d-flex col-md-6">
                                  <label className="col-md-5">
                                    Require Reason for Cash Break?
                                  </label>
                                  <select
                                    className="form-control col"
                                    value={formState?.require_reason_cash_break}
                                    onChange={(e) =>
                                      setFormState({
                                        ...formState,
                                        require_reason_cash_break:
                                          e.target.value,
                                      })
                                    }
                                  >
                                    <option value={"yes"}>Yes</option>
                                    <option value={"no"}>No</option>
                                  </select>
                                </li>

                                <li class="checkbox">
                                  <input
                                    onClick={() =>
                                      setFormState({
                                        ...formState,
                                        count_same_for_all_day:
                                          formState?.count_same_for_all_day ===
                                          1
                                            ? 0
                                            : 1,
                                      })
                                    }
                                    checked={
                                      formState?.count_same_for_all_day === 1
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    name="data[Feature][notepad_same_for_all_day]"
                                    value="1"
                                    id="sameAllDays2"
                                  />
                                  <label for="sameAllDays2">
                                    Same for all day
                                  </label>{" "}
                                </li>
                              </ul>
                            </>
                          );
                          break;
                        default:
                          break;
                      }
                      return res;
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0 w-100">
              <div class="container px-0 d-flex col-12">
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button
                    onClick={() =>
                      dispatch(actions.postClipBoardData(formState))
                    }
                    id=""
                    type="Submit"
                  >
                    Save
                  </button>
                  <button id="cancel" type="button">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CheckListModal
        clipboardData={clipboardData}
        checkListModalState={checkListModalState}
        setCheckListModalState={setCheckListModalState}
      />
    </UserInterface>
  );
};

const CheckListModal = ({
  clipboardData,
  checkListModalState,
  setCheckListModalState,
}) => {
  const dispatch = useDispatch();
  const [modalLocalState, setModalLocalState] = useState(null);
  const [dayOfYear, setDayOfYear] = useState(null);
  const [weekly, setWeekly] = useState("");

  const checklistModalDefaultState = {
    day_time_id: clipboardData?.feature?.day_time_id,
    description: "",
    recurrence: "",
    daily: "",
    weekly: "",
    monthly: "",
    anually: "",
    mdom: "",
    adoy: "",
  };
  const checklistModalSchema = yup.object().shape({
    day_time_id: yup.string().required(),
    description: yup.string().required(),
    recurrence: yup.string().required(),
    daily:
      modalLocalState?.frequency === "1"
        ? yup.string().required()
        : yup.string(),
    weekly:
      modalLocalState?.frequency === "2"
        ? yup.array().nullable().required()
        : yup.array().nullable(),
    monthly:
      modalLocalState?.frequency === "3"
        ? yup.string().required()
        : yup.string(),
    anually:
      modalLocalState?.frequency === "4"
        ? yup.string().required()
        : yup.string(),
    mdom:
      modalLocalState?.frequency === "3" && modalLocalState?.monthly === "mdom"
        ? yup.string().required()
        : yup.string(),
    adoy:
      modalLocalState?.frequency === "4" && modalLocalState?.anually === "adom"
        ? yup.string().required()
        : yup.string(),
  });
  const submitData = (data) => {
    console.log(data);
    dispatch(
      actions?.postClipBoardDescription({
        ...data,
        day_time_id: clipboardData?.feature?.day_time_id,
      })
    );
  };
  const {
    register: checklistModalRegister,
    formState: { errors: checklistModalError },
    handleSubmit: checklistFormSubmit,
    reset: checklistFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(checklistModalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: checklistModalDefaultState,
  });

  return (
    <ModelContainer
      title="Add Checklist Setup"
      open={checkListModalState}
      closeModal={() => setCheckListModalState(false)}
      submitModal={checklistFormSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            <Input
              label={"Description"}
              formRegister={checklistModalRegister}
              formError={checklistModalError}
              formKey="description"
              isModal
            />

            <Select
              label={"Frequency"}
              formRegister={checklistModalRegister}
              formError={checklistModalError}
              formKey="recurrence"
              optionsArray={clipboardData?.frequencies}
              isModal
              onChange={(e) => {
                setModalLocalState({
                  ...modalLocalState,
                  frequency: e.target.value,
                });
                setValue("daily", "");
                setValue("weekly", "");
                setValue("monthly", "");
                setValue("anually", "");
                setValue("mdom", "");
                setValue("adoy", "");
              }}
            />
            {modalLocalState?.frequency === "1" && (
              <Select
                label={"Daily"}
                formRegister={checklistModalRegister}
                formError={checklistModalError}
                formKey="daily"
                optionsArray={clipboardData?.daily}
                isModal
                onChange={(e) => {
                  setModalLocalState({
                    ...modalLocalState,
                    // frequency: e.target.value,
                  });
                }}
              />
            )}
            {modalLocalState?.frequency === "2" && (
              <MultiSelect
                label={"Weekly"}
                formRegister={checklistModalRegister}
                formError={checklistModalError}
                formKey="weekly"
                localStateValue={weekly}
                setLocalStateMethod={setWeekly}
                formFieldSetMethod={setValue}
                isModal
                optionsArray={[
                  { value: "", label: "Select All" },
                  ...clipboardData?.weekly,
                ]}
              />
            )}
            {modalLocalState?.frequency === "3" && (
              <>
                <Select
                  label={"Monthly"}
                  formRegister={checklistModalRegister}
                  formError={checklistModalError}
                  formKey="monthly"
                  optionsArray={clipboardData?.monthly}
                  isModal
                  onChange={(e) => {
                    setModalLocalState({
                      ...modalLocalState,
                      monthly: e.target.value,
                    });
                    setValue("mdom", "");
                  }}
                />

                {modalLocalState?.monthly === "mdom" && (
                  <Select
                    label={"Day of month"}
                    formRegister={checklistModalRegister}
                    formError={checklistModalError}
                    formKey="mdom"
                    optionsArray={clipboardData?.mdom}
                    isModal
                  />
                )}
              </>
            )}
            {modalLocalState?.frequency === "4" && (
              <>
                <Select
                  label={"Anually"}
                  formRegister={checklistModalRegister}
                  formError={checklistModalError}
                  formKey="anually"
                  optionsArray={clipboardData?.anually}
                  isModal
                  onChange={(e) => {
                    setModalLocalState({
                      ...modalLocalState,
                      anually: e.target.value,
                    });
                    setValue("adoy", "");
                  }}
                />

                {modalLocalState?.anually === "adom" && (
                  <DateInput
                    label="Date of year"
                    formRegister={checklistModalRegister}
                    formError={checklistModalError}
                    formKey="adoy"
                    dateVal={dayOfYear}
                    setDateVal={setDayOfYear}
                    setFormField={setValue}
                  />
                )}
              </>
            )}
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default Clipboard;
